import request from '@/utils/http';

export const geBankAccountLists = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getBankAccount`,
        method: 'get',
        params
    });
};

export const getElectronicSeal = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/electricSign`,
        method: 'post',
        data
    });
};

export const getSaveDrawBack = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/saveDrawBack`,
        method: 'post',
        data
    });
};

// 退款申请模板下载  QMO-GCF04.009-2019 F-GCF04.009-2019-01 供应商往来对帐余额调节表202003101643
export const getTemplateDownload = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getDownloadWord`,
        method: 'get',
        params
    });
};

// 退款申请模板下载  QMO-GCF04.009-2019 F-GCF04.009-2019-02 供应商业务终止登记表.doc
export const getDownload = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getDowWord`,
        method: 'get',
        params
    });
};

export const getDownloadList = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/download`,
        method: 'get',
        params
    });
};